module.exports = __webpack_public_path__ + "static/media/lineto-akkurat-pro-regular-e2c79c55a3d8e3008646082c6509929e.e2c79c55.eot";